import React, { useState, useEffect } from 'react';
import { f7, Page, Link, Button, Icon , Input } from 'framework7-react';
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';

const ProfileUpdatePage = () => {
  const [data, setData] = useState({});
  
  useEffect(() => {
    axios.get(API_BASE_URL + 'restcontprefer', {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        },
        params: {
          id: 1,
          limits: 1
        }
      })
      .then(response => setData(response.data[0]))
      .catch(error => console.log(error));
  }, []);
  
  const handleSubmit = (event) => {
    event.preventDefault();
    axios.put(API_BASE_URL + 'restcontprefer/id/'+localStorage.getItem('id'), data, {
      headers: {
        'Authorization': 'Basic ' + API_AUTH
      }
    })
      .then(response => f7.toast.create({
        text: 'Setting has been Updated..!',
        position: 'top',
        cssClass: 'bg-color-teal',
        closeTimeout: 3000
      }).open())
      .catch(error => f7.dialog.alert('Error updating data!'));
  }
 

  return (
    <Page className='bg-white'>
      {/* <Navbar title="Restaurant Information" backLink="Back" noShadow/>             */}
      <div className="container container-table  ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon> <span className='text-dark d-none d-md-block'>Back</span></Link>
                <h2>Settings</h2>
              </div>
            </div>
          </header>
            <section className="section-b-space">
              <div className="custom-container p-0">
                <form onSubmit={handleSubmit} className="auth-form profile-form">
                  <div className="form-group">
                    <label className="form-label fw-semibold">Contact Preference</label>
                    <div className="form-input mb-4">
                      <select className="form-select form-control" value={data.contact_preference} validate required placeholder="Please choose..." onChange={(event) => setData({...data, contact_preference: event.target.value})}>
                        <option value="1">Phone</option>
                        <option value="2">Email</option>
                        <option value="3">Text</option>
                        {/* <option value="4">Mail</option> */}
                      </select>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label fw-semibold">Change Password</label>
                    <div className="form-input mb-4">
                      <Input type="password" className="form-control" id="password" pattern='^(?=.*\d).{6,}$'  validate onInput={(e) =>  setData({...data, rest_password: e.target.value}) } placeholder="Your password" />
                    </div>
                  </div>
                  <Button type="submit" fill large className="btn theme-btn save-address w-100">
                    Save Changes
                  </Button>
                </form>
              </div>
            </section>
      {/* <form onSubmit={handleSubmit}>
        <List noHairlinesMd>
        <BlockHeader>Restaurant Information</BlockHeader>        
          <ListInput
            label="Restaurants Name"
            type="text"
            required
            validate
            pattern="[A-Za-z0-9 ]{3,25}"
            placeholder="Restaurants Name"
            value={data.rest_name} onInput={(event) => setData({...data, rest_name: event.target.value})}
          />          
          <ListInput
            label="Owner First Name"
            type="text"
            required
            placeholder="Owner First Name"
            value={data.rest_owner_fname} onInput={(event) => setData({...data, rest_owner_fname: event.target.value})}
          />
          <ListInput
            label="Owner Last Name"
            type="text"
            required
            placeholder="Owner Last Name"
            value={data.rest_owner_lname} onInput={(event) => setData({...data, rest_owner_lname: event.target.value})}
          />
           <ListInput
            label="EIN"
            type="text"
            required
            validate
            placeholder="EIN Number"
            value={data.rest_ein} onInput={(event) => setData({...data, rest_ein: event.target.value})}
          />
          <ListInput
            label="Email"
            type="email"
            readonly={true}
            placeholder="Your email"
            value={data.rest_email} onInput={(event) => setData({...data, rest_email: event.target.value})}
          />
          <ListInput
            label="Phone"
            type="text"
            placeholder="Your Phone Number"
            required
            validate
            pattern="[0-9]*"
            value={data.rest_contact_no} onInput={(event) => setData({...data, rest_contact_no: event.target.value})}
          />
          <ListInput
            label="Restaurants phone number"
            type="text"
            placeholder="Restaurants Phone number"
            required
            validate
            pattern="[0-9]*"
            value={data.rest_locations_no} onInput={(event) => setData({...data, rest_locations_no: event.target.value})}
          />
          <ListInput
            label="Restaurant Website"
            type="text"
            placeholder="Restaurant Website"
            validate            
            value={data.rest_website} onInput={(event) => setData({...data, rest_website: event.target.value})}
          />
        </List>
        <List>
          <BlockHeader>Address Information</BlockHeader>
          <ListInput
            label="Address"
            type="text"
            placeholder="Address"
            value={data.add_lin_1} onInput={(event) => setData({...data, add_lin_1: event.target.value})}
          />
          <ListInput
            label="Address"
            type="text"
            placeholder="Address"
            value={data.add_lin_2} onInput={(event) => setData({...data, add_lin_2: event.target.value})}
          />
          <ListInput
            label="City"
            type="text"
            placeholder="City"
            value={data.city} onInput={(event) => setData({...data, city: event.target.value})}
          />
          <ListInput
            label="State"
            type="text"
            placeholder="State"
            value={data.state} onInput={(event) => setData({...data, state: event.target.value})}
          />
          <ListInput
            label="Zip Code"
            type="text"
            placeholder="Zip Code"
            required
            validate
            pattern="[0-9]{5}"
            value={data.zip_code} onInput={(event) => setData({...data, zip_code: event.target.value})}
          />
          <Block>
            <Row>
              <Col>
                <Button type="submit" fill large raised>
                  Save Changes
                </Button>
              </Col>
            </Row>
          </Block>
        </List>
      </form> */}
        </div>
      </div>    
    </Page>
  );
}
export default ProfileUpdatePage;
